import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

import Group from 'components/utils/Group'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'

const GridContainer = styled.div`
  display: grid;
  gap: ${rem(20)};
  grid-template-columns: repeat(2, 1fr);
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(4, 1fr)
  }
`

function MerchandiseBrandsSkeleton() {
  return <Group direction="vertical" gap={16}>
    <TextLoadingBox typography="body-large" width="4ch" />

    <GridContainer>
      <TextLoadingBox typography="body-medium" width="16ch" />
      <TextLoadingBox typography="body-medium" width="16ch" />
      <TextLoadingBox typography="body-medium" width="16ch" />
      <TextLoadingBox typography="body-medium" width="16ch" />
      <TextLoadingBox typography="body-medium" width="16ch" />
      <TextLoadingBox typography="body-medium" width="16ch" />
      <TextLoadingBox typography="body-medium" width="16ch" />
      <TextLoadingBox typography="body-medium" width="16ch" />
    </GridContainer>
  </Group>
}

export default MerchandiseBrandsSkeleton
